export default "__VITE_ASSET__CPd8$pTh__"